import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetchCourse } from "../../processes/courseProcesses";
import { fetchCourseFiles } from "../../processes/courseFileProcesses";
import { fetchLessonFilesByCourse } from "../../processes/lessonFileProcesses";
import { fetchLessons } from "../../processes/lessonProcesses";
import { fetchLevels } from "../../processes/levelProcesses";
import DownloadsCourseSections from "./DownloadsCourseSections";
import { getCourseFilesByCourseId } from "../../selectors/courseFileSelectors";
import { getLessonFilesByCourseId } from "../../selectors/lessonFileSelectors";

function DownloadsCourseSectionsContainer(props) {
  const { dispatch, activeCourseId } = props;

  useEffect(() => {
    if (!activeCourseId) return;

    const fetchData = async () => {
      await fetchCourse(dispatch, activeCourseId);
      await fetchCourseFiles(dispatch, activeCourseId);
      await fetchLessonFilesByCourse(dispatch, activeCourseId);
      await fetchLessons(dispatch, activeCourseId);
      await fetchLevels(dispatch, activeCourseId);

      dispatch({ type: "DOWNLOADS_COURSE_DATA_FETCHED" });
    };

    fetchData();
  }, [dispatch, activeCourseId]);

  return <DownloadsCourseSections {...props} />;
}

function mapStateToProps(state) {
  const activeCourseId = state.downloads.activeCourseId;

  return {
    activeCourseId,
    loading: state.downloads.loading,
    courseFiles: getCourseFilesByCourseId(state, activeCourseId),
    lessonFiles: getLessonFilesByCourseId(state, activeCourseId),
  };
}

export default connect(mapStateToProps)(DownloadsCourseSectionsContainer);
